// extracted by mini-css-extract-plugin
export default {"boardTasks":"TaskList_boardTasks__YeWPV","boardNoTasks":"TaskList_boardNoTasks__bJYVo"};